import addressModel from "@/models/address";

export default {
    address: new addressModel(),
    date: new Date().toISOString().substr(0, 10),
    discountPercent: 0,
    numberOfDays: 6,
    products: [],
    sellOff: null,
    totalTtc: 0,
    totalWithoutDiscountTtc: 0,
    tvaRate: 0.2,
    warranty: false,
    warrantyDutyFree: 1.6666666666667,
}